import React from 'react';
import { formatStatusValue } from '../../utils/formatStatus';
import './ChangeDiff.scss';

const formatValue = (key, value) => {
    const statusLabel = formatStatusValue(key, value);
    if (statusLabel) return statusLabel;
    if (value === null || value === undefined) return 'null';
    if (typeof value === 'boolean') return value ? 'true' : 'false';
    if (typeof value === 'object') return JSON.stringify(value);
    return String(value);
};

const ChangeDiff = ({ changes }) => {
    if (!changes || Object.keys(changes).length === 0) {
        return null;
    }

    return (
        <div className="change-diff">
            {Object.entries(changes).map(([field, { before, after }]) => (
                <div key={field} className="change-item">
                    <span className="field-name">{field}:</span>
                    <span className="value-before">{formatValue(field, before)}</span>
                    <span className="arrow fas fa-arrow-right" />
                    <span className="value-after">{formatValue(field, after)}</span>
                </div>
            ))}
        </div>
    );
};

export default ChangeDiff;
